import React from 'react';
import styled from 'styled-components';
import {
  boxShadow,
  maxWidth,
  primaryColor,
  primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import ContentArticleTile from './ContentArticleTile';

const Body = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 18px 14px;
  margin-bottom: 10px;
  .body-item {
    min-width: 20%;
    width: 20%;
    font-size: 20px;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    color: #424B50;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 16px;
    }
    &:nth-child(1) {
      min-width: 40%;
      width: 40%;
    }
    &:nth-child(2), &:nth-child(3), &:nth-child(4) {
     text-align: center;
    }
    &.body-accounts {
      font-size: 16px;
      color: ${primaryColor};
      font-weight: ${wMedium};
    }
  }
  .popover-sharing {
   svg {
    margin-top: 4px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 0px;
    }
   }
  }
  .share-icons-wrapper .teams-share-button:before{
      top: 6px;
      width: 14.5px;
      height: 14.5px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      top: 4px;
      width: 14.5px;
      height: 14.5px;
    }
  }
`;

type Props = {
  title?: string,
  actionAddBtn?: () => void,
  articleImg?: string,
  categoriesText?: string,
  categoriesColor?: string,
  viewsCount?: number,
  sharesCount?: number,
  isFavorite?: boolean,
  articleLink: string;
  date: string;
  domain: string;
  handleArticleShare?: () => void;
  alertId: number
  url: string
  articleId?: number
} | typeof defaultProps;

const defaultProps = {
  title: '',
  actionAddBtn() { },
  articleImg: '',
  categoriesText: '',
  categoriesColor: '',
  viewsCount: 0,
  sharesCount: 0,
  isFavorite: false,
  articleLink: '',
  date: '',
  domain: '',
  handleArticleShare: () => { },
  alertId: 0,
  url: '',
  articleId: 0,
};

const EngagementContentTableBody = function EngagementContentTableBody(props: Props) {
  const {
    title, actionAddBtn, articleImg,
    categoriesText, categoriesColor,
    viewsCount, sharesCount, isFavorite,
    articleLink, date, domain, alertId,
    handleArticleShare, url, articleId
  } = props;
  return (
    <Body>
      <div className="body-item body-profile">
        <ContentArticleTile
          title={title}
          articleId={articleId}
          actionAddBtn={actionAddBtn}
          articleImg={articleImg}
          isFavorite={isFavorite}
          articleLink={articleLink}
          // hideAddToFavorite
          date={date}
          domain={domain}
          hideAddToFavorite={false}
          shareAction={handleArticleShare}
          alertId={alertId}
          url={url}
        />
      </div>
      <div className="body-item body-accounts" style={{ color: categoriesColor }}>{categoriesText}</div>
      <div className="body-item">{viewsCount}</div>
      <div className="body-item">{sharesCount}</div>
    </Body>
  );
};

EngagementContentTableBody.defaultProps = defaultProps;
export default EngagementContentTableBody;
